"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CurrencyButton_1 = __importDefault(require("../Currency/CurrencyButton"));
var SelectionTypeButton_1 = __importDefault(require("../SelectionType/SelectionTypeButton"));
var InvoiceSettingsButton = require("../Integrations/InvoiceSettingsButton");
var isUsingTCDC = require("@CommonFrontendBackend/FeatureFlag").isUsingTCDC;
module.exports = function (make, integrationService, StyleButton, BlockControls, usingFeature) {
    var e_1, _a, e_2, _b;
    var styleButton = make(StyleButton);
    var blockControls = make(BlockControls);
    var currencyButton = make(CurrencyButton_1.default);
    var selectionTypeButton = make(SelectionTypeButton_1.default);
    var superpowers = [];
    if (isUsingTCDC(usingFeature)) {
        superpowers.push({
            name: "Style library",
            ctrl: styleButton,
            selectable: false,
            select: styleButton.onClick,
            deselect: styleButton.onClose,
            overflow: true,
        });
    }
    superpowers.push({
        name: "Block Controls",
        ctrl: blockControls,
        doNotWrapControl: true,
        visibleOnViewOnlyBlocks: true,
    });
    superpowers.push({
        name: "Quote type",
        ctrl: selectionTypeButton,
        selectable: true,
        select: selectionTypeButton.onClick,
        deselect: selectionTypeButton.onClose,
    }, {
        name: currencyButton.buttonName(),
        ctrl: currencyButton,
        doNotWrapControl: true,
        selectable: true,
        select: currencyButton.onClick,
        deselect: currencyButton.onClose,
    });
    var invoicerButtons = [];
    try {
        for (var _c = __values(integrationService.getEnabledAccountingIntegrations()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var integration = _d.value;
            invoicerButtons.push(make(InvoiceSettingsButton, { integration: integration.internalName }));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var invoicerButtons_1 = __values(invoicerButtons), invoicerButtons_1_1 = invoicerButtons_1.next(); !invoicerButtons_1_1.done; invoicerButtons_1_1 = invoicerButtons_1.next()) {
            var invoicerButton = invoicerButtons_1_1.value;
            superpowers.push({
                name: invoicerButton.name,
                ctrl: invoicerButton,
                selectable: true,
                select: invoicerButton.onClick,
                deselect: invoicerButton.onClose,
            });
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (invoicerButtons_1_1 && !invoicerButtons_1_1.done && (_b = invoicerButtons_1.return)) _b.call(invoicerButtons_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    var configuration = {
        settings: {
            useItems: ["navigationMenu"],
            superpowers: superpowers,
            items: [
                {
                    name: "Display options",
                    description: "Choose the display options for your quote",
                    ctrl: make(require("./Controls/GlobalDisplays")),
                },
                {
                    name: "Formatting",
                    description: "Change the way numbers are displayed in your quote",
                    ctrl: make(require("./Controls/Formatting")),
                },
                {
                    name: "Language Overrides",
                    description: "Make the labels in your quote native to who it’s shared with",
                    ctrl: make(require("./Controls/LanguageOverrides").default),
                },
                {
                    name: "Tax Library",
                    description: "Manage taxes that are applied to your quote",
                    ctrl: make(require("./Controls/Taxes")),
                },
                {
                    name: "Recurring costs",
                    description: "",
                    ctrl: make(require("./Controls/RecurringCosts").default),
                },
            ],
        },
    };
    return configuration;
};
